// extracted by mini-css-extract-plugin
export var blogHeading = "BlogCard-module--blogHeading--1ee34";
export var imageLink = "BlogCard-module--imageLink--27eb6";